import {Injectable} from '@angular/core';
import {StoreService} from '../modules/akita-mimic/services/store.service';
import {BrowserState} from '../modules/akita-mimic/models/store-states/browser-state.model';

@Injectable({ providedIn: 'root' })
export class BrowserStore extends StoreService<BrowserState> {
    public constructor() {
        super('browser', {
            orientation: undefined,
            hasSmallViewport: false,
            isOnline: false,
        });
    }
}
